<span class="!inline-flex !shrink-0 !items-center !gap-1.5 !rounded-full !px-2.5 !py-1 !text-[11px] !font-bold !uppercase !tracking-wide !leading-none"
      [ngClass]="toneClasses"
      [attr.title]="status">
    <span class="!h-1.5 !w-1.5 !rounded-full !bg-current" aria-hidden="true"></span>
    {{ label }}
</span>
